{
  "nav": {
    "home": "Inicio",
    "scouting": "Ojeo",
    "reports": "Informes",
    "settings": "Ajustes"
  },
  "settings": {
    "language": "Idioma",
    "languageDescription": "Elige el idioma que se usa en toda la aplicación.",
    "save": "Guardar"
  },
  "reports": {
    "title": "Informes de ojeo",
    "empty": "Aún no hay informes",
    "generateSummary": "Generar resumen",
    "translationUnavailable": "Traducción no disponible. Se muestra el informe original.",
    "retryTranslation": "Reintentar",
    "matchesHeading_one": "Partido:",
    "matchesHeading_other": "Partidos:",
    "matchLineHome": "vs {{opponent}} el {{date}}",
    "matchLineAway": "en {{opponent}} el {{date}}",
    "matchLineNeutral": "{{opponent}} el {{date}}",
    "editorTitle": "Editar informe de ojeo",
    "untitled": "Informe",
    "authorSelf": "Tú",
    "sharedBadge": "Compartido",
    "shareAction": "Compartir",
    "sharedAction": "Compartido",
    "back": "Atrás",
    "editedBy": "Editado por",
    "createdBy": "Creado por",
    "translate": "Traducir",
    "translating": "Traduciendo...",
    "showOriginal": "Ver original",
    "download": "Descargar",
    "downloading": "Descargando...",
    "edit": "Editar",
    "archive": "Archivar"
  },
  "language": {
    "control": "Idioma",
    "selectTitle": "Seleccionar idioma",
    "change": "Cambiar idioma",
    "changeCurrent": "Cambiar idioma, actualmente {{language}}",
    "changeStranded": "Cambiar idioma. Tu idioma guardado {{code}} ya no está disponible, por lo que se usa {{language}} en su lugar.",
    "generate": "Generar · {{language}}",
    "generateAccessibility": "Idioma del resumen generado",
    "saveDefault": {
      "idle": "Guardar como mi idioma predeterminado",
      "saving": "Guardando…",
      "saved": "Guardado como tu idioma predeterminado",
      "alreadyDefault": "Este ya es tu idioma predeterminado",
      "error": "No se pudo guardar: toca para reintentar",
      "warning": "Solo se aplica a este resumen. Guárdalo como tu idioma predeterminado o tendrás que generarlo de nuevo la próxima vez.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "No se pudo guardar tu idioma predeterminado. Inténtalo de nuevo."
    }
  }
}
